import { LANGS } from "@/lib/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe } from "lucide-react";

export default function LanguageSelector({ value, onChange }) {
  const current = LANGS.find((l) => l.code === value) || LANGS[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="lang-trigger"
        className="glass px-3 py-2 rounded-full text-xs tracking-[0.2em] uppercase font-bold flex items-center gap-2 hover:bg-white/90 transition-colors"
      >
        <Globe className="w-3.5 h-3.5" strokeWidth={1.75} />
        <span>{current.flag}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-opt-${l.code}`}
            onClick={() => onChange(l.code)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span>{l.label}</span>
            <span className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground">{l.flag}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
